const fetchUser = async (userId) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  console.log('**',userId)
  const response = await fetch(`${apiUrl}authentication/user_list/${userId}/`, {
    headers: {
      "Content-type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });

  if (response.status === 401) {
    throw new Error("Unauthorized");
  }

  return await response.json();
};

export { fetchUser };